import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import {
  Checkout2,
  ErrorPage,
  // FlowPage,
  PaymentGetways,
  ProductPage,
  SuccessPage,
  TreatementSelection,
  UpdatePayment,
  WeightLoss,
} from "./pages";
import { Footer, Navbar } from "./common";
import NewPage from "./pages/NewPage";
import ThankYou3 from "./pages/paymentgetway/ThankYou3";
import { preparePapAffiliateInBrowserUrl, trackPostAffiliateClick } from "./utils/postAffiliatePro";

/** PAP click: normalize URL, promote #a_aid to ?a_aid, then setAccountId + track() */
function PostAffiliateProRouteSync() {
  const location = useLocation();
  useEffect(() => {
    preparePapAffiliateInBrowserUrl();
    trackPostAffiliateClick();
  }, [location.pathname, location.search, location.hash]);
  return null;
}

const App = () => {
  return (
    <>
      <BrowserRouter basename="/l">
        <PostAffiliateProRouteSync />
        {/* <Navbar /> */}

        <Routes>
          {/* <Route path="/" element={<WeightLoss />} />
          <Route path="/ProductPage" element={<ProductPage />} />
          <Route path="/PaymentGetways" element={<PaymentGetways />} />
          <Route path="/FlowPage" element={<FlowPage />} />
          <Route
          path="/TreatementSelection"
          element={<TreatementSelection />}
        /> */}
          <Route path="/SuccessPage" element={<SuccessPage />} />
          <Route path="/ErrorPage" element={<ErrorPage />} />
          <Route path="/UpdatePayment/:id" element={<UpdatePayment />} />
          {/* <Route path="/thankyou-page" element={<NewThankyouPage />} /> */}
          {/* <Route path="/thank-you-3" element={<ThankYou3 />} /> */}
          <Route path="/thankyou-page" element={<ThankYou3 />} />
          {/* Checkout: query-only URLs like /l/?sku=... need path "/" */}
          <Route path="/" element={<Checkout2 />} />
          <Route path="/:idValue" element={<Checkout2 />} />
          <Route path="*" element={<ErrorPage />} />

          {/* <Route path="/NewPage" element={<NewPage />} /> */}
        </Routes>
        {/* <Footer /> */}
      </BrowserRouter>
    </>
  );
};

export default App;
